import { InnerBox } from "@/components/elements/InnerBox";
import { TalentFormEducationFields } from "@/features/talent/components/talent-form/TalentFormEducationFields";
import { TalentFormHeldQualificationsFields } from "@/features/talent/components/talent-form/TalentFormHeldQualificationsFields";
import { TalentFormLanguageSkillsFields } from "@/features/talent/components/talent-form/TalentFormLanguageSkillsFields";
import { divider, black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Stack, Box, Typography } from "@mui/material";

type TalentFormEducationBackgroundProps = {};

export const TalentFormEducationBackground: FCC<TalentFormEducationBackgroundProps> = () => {
  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>
          <Typography variant="head20Bold" color={black[30]}>
            学歴・保有資格
          </Typography>
        </Box>
      </Stack>

      <TalentFormEducationFields />
      <TalentFormHeldQualificationsFields />
      <TalentFormLanguageSkillsFields />
    </InnerBox>
  );
};
